// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "button-3q7EJ";
var _5 = "button__icon-17Z8v";
var _6 = "button__icon_reversed-Ay-X4";
var _7 = "button__text-wSI3l";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "button", _5 as "button__icon", _6 as "button__icon_reversed", _7 as "button__text" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "button": _4, "button__icon": _5, "button__icon_reversed": _6, "button__text": _7 }
